const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9,0A3.93,3.93,0,0,0,5.07,3.94c0,1.76,2.57,5,3.55,6.12a.49.49,0,0,0,.7.06l.06-.06c1-1.16,3.55-4.36,3.55-6.12A3.93,3.93,0,0,0,9,0ZM9,5.25a1.32,1.32,0,1,1,1.31-1.31h0A1.31,1.31,0,0,1,9,5.25ZM.63,6.75A1,1,0,0,0,0,7.68V15.5a.5.5,0,0,0,.5.5.43.43,0,0,0,.19,0L5,14V6.72a9.94,9.94,0,0,1-.66-1.45ZM9,11.24a1.51,1.51,0,0,1-1.14-.53C7.24,10,6.59,9.16,6,8.31V14l6,2V8.31a29.74,29.74,0,0,1-1.86,2.4A1.47,1.47,0,0,1,9,11.24ZM17.31,5,13,7v9l4.37-1.75a1,1,0,0,0,.63-.93V5.5a.5.5,0,0,0-.5-.5A.43.43,0,0,0,17.31,5Z",
    style: {
      fill: "#ccc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.3578d8ee23011b1ccf5fc2e45a6358ae.svg";
export { ForwardRef as ReactComponent };